import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IProductType } from '@cakeiteasy/web-utils';

import { getRequestUrl } from './helpers';

@Component({
  standalone: false,
  selector: 'request-form-product-view',
  templateUrl: './request-form-product-view.component.html',
  styleUrls: ['./request-form-product-view.component.scss'],
  // its pure representational component: only input and output
  // avoid unnecessary checks
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFormProductViewComponent implements OnInit {
  @Input() cake: IProductType;
  @Input() showBakeryName = true;
  @Output() onSendRequest = new EventEmitter<string>();

  public hasImages: boolean;

  ngOnInit() {
    this.hasImages = this.cake && this.cake.images && this.cake.images.length > 0;
  }

  public handleOnSendRequest(): void {
    const link = getRequestUrl(this.cake);
    this.onSendRequest.emit(link);
  }
}
